import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { Router, ActivatedRoute } from "@angular/router";
import { SportService } from '../services/sport.service';
import * as moment from 'moment';
import { resolve } from 'q';
import { ToastrService } from 'ngx-toastr';
import { SocketServiceService } from '../services/socket-service.service';
import { LoginService } from '../services/login.service'
import { CookieService } from 'ngx-cookie-service';
import { ReportService } from '../services/report.service';
@Component({
  selector: 'app-multi-market',
  templateUrl: './multi-market.component.html',
  styleUrls: ['./multi-market.component.scss'],
  providers: [HeaderComponent, SidebarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiMarketComponent implements OnInit {
  moment: any = moment;
  homeData: any;
  public timer: any;
  allSportsList: any;
  userData: any;
  firstData: any;
  parameter: any;
  a: any = [];
  runnerData: any;
  combineData: any;
  Data: any;
  finalData: any;
  isSocket;
  runnerDataLength: any;
  firstDataLength: any;
  updateRunnerData: any = [];
  exchangeGameList: any;
  dataLength: any;
  marketId: any = [];
  callType = 1;
  marketData: any = [];
  socketData: any;
  callingType = 1;
  updateFirstData: any = [];
  token: string;
  operator_id: string;
  games: string;
  adminHeading: string;
  allData: any;
  adminData: any;
  
  constructor(private loginService: LoginService,private reportService: ReportService,private head: HeaderComponent, private cdRef: ChangeDetectorRef, private cookie: CookieService, private socketService: SocketServiceService, private route: ActivatedRoute, private router: Router, private sport: SportService, private toastr: ToastrService) { 
    this.socketService.onSuccess.subscribe(res => {
      this.socketSuccess(res);
    })
  }

  socketStatus(){
    this.sport.getSocketStatus().subscribe((res) => {
      this.isSocket = res.is_socket;
        this.socketService.setUpSocketConnection();
        this.socketListenersUser();
        this.socketError();
        this.userData = {
          "my_favorites": true
        };
        this.homematches();
    })
  }
  async ngOnInit() {
    this.socketStatus()
    this.getNews();
  }
  socketOnEvent(eventName, callback) {
    this.socketService.socket.on(eventName, data => callback(data));
  }

  socketEmitEvent(eventName, data) {
    this.socketService.socket.emit(eventName, data);
  }
  socketError() {
    this.socketService.socket.on(`error`, (res) => {
      if (res.status == false) {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }
  socketSuccess(res) {
    // this.socketService.socket.on('success', (res) => {
    if (res.status == true) {
      if (res.event_code == "subscribe_event") {
        this.marketData = [];
        for (let i = 0; i < this.marketId.length; i++) {
          this.socketOnEvent(this.marketId[i], result => {
            if (result.status == true) {
              this.marketData = result.data;
              this.runnerDataLength = this.marketData.length;
              this.runnerData = this.marketData;
              for (let i = 0; i < this.firstData.length; i++) {
                if (this.firstData[i].marketId == this.runnerData.marketId) {
                  this.firstData[i].runners = this.runnerData.runners;
                  this.firstData[i].status = this.runnerData.status;
                  this.firstData[i].inplay = this.runnerData.inplay;
                  this.socketData = this.firstData[i]
                  break
                }
              }
              // for (let i = 0; i < (this.homeData).length; i++) {
              //   if ((this.homeData)[i] == this.socketData.sport_name) {
              //     let key = Object.values(this.homeData)[i];
              //     for (let l = 0; l < Object.keys(key).length; l++) {
              //       if (key[l].marketId == this.socketData.marketId) {
              //         key[l].runners = this.socketData.runners;
              //         key[l].status = this.socketData.status;
              //         key[l].inplay = this.socketData.inplay;
              //       }
              //     }
              //   }
              // }
              for(let i=0 ; i< this.homeData.length; i++){
                if(this.homeData[i].marketId == this.socketData.marketId){
                  this.homeData[i].runners = this.socketData.runners;
                  this.homeData[i].status = this.socketData.status;
                  this.homeData[i].inplay = this.socketData.inplay;
                }
              }
              this.cdRef.detectChanges();
            }
          })
        }
      } else {
        this.toastr.success(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        })
      }
    }
    // })
  }
  getRunnerEmit() {
    for (let i = 0; i < this.firstData.length; i++) {
      this.marketId.push(this.firstData[i].marketId)
    }
    let event = {
      "eventIds": this.marketId
    }
    this.socketEmitEvent('subscribe_event', event);
  }

  marketAdded() {
    this.userData = {};
    this.socketEmitEvent('new_market_added', this.userData);
  }
  ngOnDestroy() {
    this.socketService.socket.close();
  }
  socketListenersUser() {
    this.socketOnEvent(`homeMatches`, res => {
      // try {
      // if (res.status) {
      this.firstData = res.data;
      this.firstDataLength = this.firstData.length
      for (let i = 0; i < this.firstData.length; i++) {
        this.marketId.push(this.firstData[i].marketId)
      }
      this.getRunnerEmit();
      // }
      // } catch (e) {
      //   this.homematches()
      // }
    });

    this.socketOnEvent(`subscribe_event`, res => {
    });
    this.socketOnEvent(`unsubscribe_event`, res => {
    });
    this.socketOnEvent(`new_market_added`, res => {
      if (res.status == true) {
        this.toastr.success(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        })
        this.homematches();
      }
    });
    this.socketOnEvent(`socket_state_changed`, res => {
      this.isSocket = res.is_socket
      this.route.params.subscribe(params => {
        if (params.sportName == undefined) {
          this.userData = {};
          this.homematches();
        } else {
          this.parameter = params.sportName;
          this.homematches();
        }
      })
      if (this.isSocket == 0) {
        this.marketId = [];
        for (let i = 0; i < this.firstData.length; i++) {
          this.marketId.push(this.firstData[i].marketId)
        }
        let event = {
          "eventIds": this.marketId
        }
        this.socketEmitEvent('unsubscribe_event', event);
      } else {
        clearTimeout(this.timer);
      }
    });
  }

  getHomeMatchCallEvent(param) {
    this.userData = {};
    this.socketEmitEvent('homeMatches', this.userData);
  }
  getNews() {
      let data = {};
      this.reportService.getNews(data).subscribe((res) => {
        if (res.status) {
          if (res.data == null) {
            this.adminHeading = '';
          } else {
            this.allData = res.data;
            this.adminData = this.allData.filter(t => t.user_type_id == 0);
            if (this.adminData.length != 0) {
              this.adminHeading = this.adminData[0].heading;
            }
          }
        }
      })
    }
    homematches() {
      this.sport.getHomeMatchesList(this.userData).subscribe(res => {
        if (res.status) {
          // this.socketService.socket.connected;
          this.marketId = [];
          if (this.callingType == 1) {
            this.firstData = res.data;
            this.callingType = 2;
            this.firstDataLength = this.firstData.length;
            console.log("291",this.firstDataLength);
            if(this.firstDataLength > 0){
              for (let i = 0; i < this.firstDataLength; i++) {
                this.firstData[i].manualInplay = this.firstData[i].inplay
              }
              this.firstData.forEach(matDta => {
                matDta.manualInplay = matDta.inplay;
              });
              if (this.isSocket == 1) {
                for (let i = 0; i < this.firstData.length; i++) {
                  this.updateRunnerData[i] = {
                    "marketId": this.firstData[i].marketId,
                    "status": "SUSPENDED",
                    "inplay": false,
                    "runners": [
                      {
                        "ex": {
                          "availableToBack": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "availableToLay": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "tradedVolume": []
                        }
                      },
                      {
                        "ex": {
                          "availableToBack": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "availableToLay": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "tradedVolume": []
                        }
                      }
                    ]
                  }
                }
                const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }));
                this.a = a3;
                let matches;
                if (this.parameter == undefined || this.parameter == 'All') {
                  matches = this.a;
                  this.dataLength = matches.length;
                } else if (this.parameter == 'inplay') {
                  matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
                  this.dataLength = matches.length;
                } else {
                  matches = this.a.filter(t => t.sport_name == this.parameter);
                  this.dataLength = matches.length;
                }
                // matches = matches.reduce((groupSport, sports) => {
                //   const { sport_name } = sports;
                //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
                //   return groupSport;
                // }, {});
                this.homeData = matches;
                console.log("327",this.homeData);
                
                this.getRunnerEmit();
              } else {
                this.runners();
              }
            }
           this.cdRef.detectChanges();
          } else {
            this.firstData = res.data;
            this.firstDataLength = this.firstData.length;
            if(this.firstDataLength > 0){

              for (let i = 0; i < this.firstDataLength; i++) {
                this.firstData[i].manualInplay = this.firstData[i].inplay
              }
              this.firstData.forEach(matDta => {
                matDta.manualInplay = matDta.inplay;
              });
              if (this.isSocket == 1) {
                for (let i = 0; i < this.firstData.length; i++) {
                  this.updateRunnerData[i] = {
                    "marketId": this.firstData[i].marketId,
                    "status": "SUSPENDED",
                    "inplay": false,
                    "runners": [
                      {
                        "ex": {
                          "availableToBack": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "availableToLay": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "tradedVolume": []
                        }
                      },
                      {
                        "ex": {
                          "availableToBack": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "availableToLay": [
                            {
                              "price": "--",
                              "size": "--"
                            }
                          ],
                          "tradedVolume": []
                        }
                      }
                    ]
                  }
                }
                const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }));
                this.a = a3;
                let matches;
                if (this.parameter == undefined || this.parameter == 'All') {
                  matches = this.a;
                  this.dataLength = matches.length;
                } else if (this.parameter == 'inplay') {
                  matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
                  this.dataLength = matches.length;
                } else {
                  matches = this.a.filter(t => t.sport_name == this.parameter);
                  this.dataLength = matches.length;
                }
                // matches = matches.reduce((groupSport, sports) => {
                //   const { sport_name } = sports;
                //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
                //   return groupSport;
                // }, {});
                this.homeData = matches;
                this.getRunnerEmit();
              } else {
                this.runners();
              }
            }
            this.cdRef.detectChanges();
          }
  
        } else {
          this.toastr.error(res.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
          if (res.logout == true) {
            // this.head.logoutUser();
          }
        }
      }, (err) => {
        console.log(err);
      },
        () => {
          if (this.router.url.split('?')[0] == '/dashboard') {
            if (this.isSocket != 1) {
              this.timer = setTimeout(() => resolve(this.homematches()), 10000);
            } else {
              clearTimeout(this.timer);
            }
          }
        })
    }
    runners() {
      this.userData = {};
      this.sport.runnerList(this.userData).subscribe((res) => {
        if (res.status) {
          this.runnerDataLength = res.data.length;
          this.runnerData = res.data;
          for (let i = 0; i < this.firstDataLength; i++) {
            for (let j = 0; j < this.runnerDataLength; j++) {
              if (this.firstData[i].marketId == this.runnerData[j].marketId) {
                this.updateRunnerData[i] = []
                this.updateRunnerData[i] = (this.runnerData[j]);
                break
              } else {
                this.updateRunnerData[i] = {
                  "marketId": this.firstData[i].marketId,
                  "status": "SUSPENDED",
                  "inplay": false,
                  "runners": [
                    {
                      "ex": {
                        "availableToBack": [
                          {
                            "price": "--",
                            "size": "--"
                          }
                        ],
                        "availableToLay": [
                          {
                            "price": "--",
                            "size": "--"
                          }
                        ],
                        "tradedVolume": []
                      }
                    },
                    {
                      "ex": {
                        "availableToBack": [
                          {
                            "price": "--",
                            "size": "--"
                          }
                        ],
                        "availableToLay": [
                          {
                            "price": "--",
                            "size": "--"
                          }
                        ],
                        "tradedVolume": []
                      }
                    }
                  ]
                }
              }
            }
          }
          const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }))
          // var original = [...this.firstData, ...this.updateRunnerData],
          //   updateRunners = Array.from(
          //     original
          //       .reduce(
          //         (m, o) => m.set(o.match_id, Object.assign({}, m.get(o.match_id) || {}, o)),
          //         new Map
          //       )
          //       .values()
          //   );
          this.a = a3;
          let matches;
          if (this.parameter == undefined || this.parameter == 'All') {
            matches = this.a;
            this.dataLength = matches.length;
          } else if (this.parameter == 'inplay') {
            matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
            this.dataLength = matches.length;
          } else {
            matches = this.a.filter(t => t.sport_name == this.parameter);
            this.dataLength = matches.length;
          }
          // matches = matches.map(data => {
          //   if (!Array.isArray(data.runners))
          //     data.runners = data.runners.runners;
          //   return data;
          // })
          // matches = matches.reduce((groupSport, sports) => {
          //   const { sport_name } = sports;
          //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
          //   return groupSport;
          // }, {});
  
          this.homeData = matches;
          this.a = [];
          // original = [];
          // } else {
          //   // this.homematches();
          // }
  
        } else {
          for (let i = 0; i < this.firstDataLength; i++) {
            this.updateRunnerData[i] = {
              "marketId": this.firstData[i].marketId,
              "status": "SUSPENDED",
              "inplay": false,
              "runners": [
                {
                  "ex": {
                    "availableToBack": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "availableToLay": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "tradedVolume": []
                  }
                },
                {
                  "ex": {
                    "availableToBack": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "availableToLay": [
                      {
                        "price": "--",
                        "size": "--"
                      }
                    ],
                    "tradedVolume": []
                  }
                }
              ]
            }
          }
          const a3 = this.firstData.map(t1 => ({ ...t1, ...this.updateRunnerData.find(t2 => t2.marketId === t1.marketId) }));
          this.a = a3;
          let matches;
          if (this.parameter == undefined || this.parameter == 'All') {
            matches = this.a;
            this.dataLength = matches.length;
          } else if (this.parameter == 'inplay') {
            matches = this.a.filter(t => t.inplay == true || t.manualInplay == true);
            this.dataLength = matches.length;
          } else {
            matches = this.a.filter(t => t.sport_name == this.parameter);
            this.dataLength = matches.length;
          }
          // matches = matches.map(data => {
          //   if (!Array.isArray(data.runners))
          //     data.runners = data.runners.runners;
          //   return data;
          // })
          // matches = matches.reduce((groupSport, sports) => {
          //   const { sport_name } = sports;
          //   groupSport[sport_name] = [...groupSport[sport_name] || [], sports];
          //   return groupSport;
          // }, {});
          this.homeData = matches;
          
          this.a = [];
        }
      }, (err) => {
        console.log(err);
      }
        // , () => {
        //   if (this.router.url.split('?')[0] == '/dashboard' || this.router.url.split('?')[0] == '/dashboard/' + this.parameter) {
        //     this.timer = setTimeout(() => resolve(this.runners()), 1000);
        //   }
        // }
      )
    }
    matchDetail(matchData) {
      localStorage.setItem('matchData', JSON.stringify(matchData));
      this.router.navigate(['match-detail']);
    }
  
    multi() {
      this.router.navigate(['multiMarket'])
    }
    inplay() {
      this.router.navigate(['inplay'])
    }
    goToAll(sportName) {
      this.router.navigate(['dashboard/' + sportName]);
    }
}
